/*
 * videojs doesn't play nicely with the typical module-based NPM/Webpack
 * build process.  So for now we consolidate these steps here so that
 * they can be included in the base Player.js file and executed
 * automatically when other people import that module.
 */
/* global window */

import videojs from 'video.js';
import './playlists';

/* eslint-disable */
import 'node_modules/video.js/dist/video-js.css';
import 'node_modules/videojs-ima/dist/videojs.ima.css';
import 'node_modules/videojs-dock/dist/videojs-dock.css';
import 'node_modules/videojs-contrib-ads/dist/videojs.ads.css';

window.videojs = videojs;

require('videojs-contrib-ads');
require('videojs-contrib-hls');
require('videojs-contrib-quality-levels');
require('videojs-ima');
require('videojs-dock');

// this polyfill is required for Safair 9.x compatibility
require('url-search-params');

// needs to be imported here because it depends on videojs being instantiated
import './sharing';
import './playlistControls';
import './playlistControls/overlay';
import './quality';

import './sharing/videojs-share.css';
import './playlistControls/base.css';
import './quality/base.css';

/* eslint-enable */



// WEBPACK FOOTER //
// ./node_modules/video-js-core/src/bootstrap.js